/* eslint-disable @next/next/no-html-link-for-pages */

import Head from 'next/head';
import Link from 'next/link';

const Page = () => {
  return (
    <>
      <Head>
        <title>Wort-/Bildmarken</title>
      </Head>

      <h1>Wort-/Bildmarken</h1>

      <p className="text__lead">
        Die Wort-/Bildmarken (Logos) der FHNW können zur Nutzung auf Webdiensten
        über das Branding-Portal bezogen werden.
      </p>
      <p>
        Plattformen mit Standard-Design integrieren die Wort-/Bildmarke im
        vorgegebenen Header (vgl.{' '}
        <Link
          href={`${process.env.NEXT_PUBLIC_BASE_URL}/basic-elements/webdienst-header`}
          title="PAAS - Webdienst-Header"
        >
          Webdienst-Header
        </Link>{' '}
        bzw.{' '}
        <Link
          href={`${process.env.NEXT_PUBLIC_BASE_URL}/basic-elements/tools-header`}
        >
          Tools-Header
        </Link>
        ).
      </p>

      <p>
        Auf Online-Plattformen im Custom-Design ist jeweils die vollständige
        Wort-/Bildmarke gemäss den{' '}
        <a
          title="Branding - Wort-/Bildmarken"
          href={`${process.env.NEXT_PUBLIC_BASE_URL}/corporate-design/webdienste/`}
          target="_blank"
        >
          CD-Vorgaben
        </a>{' '}
        links oben einzubinden. Für die Nutzung stehen im{' '}
        <a
          title="FHNW Branding Portal"
          href="https://branding.fhnw.ch/document/13"
          target="_blank"
        >
          FHNW Branding Portal
        </a>{' '}
        die Wort-/Bildmarken in den Formaten PNG, SVG, JPG und EPS als Download
        zur Verfügung.
      </p>
      <p>
        Bitte beachten Sie für den Einsatz das entsprechende{' '}
        <a
          title="FHNW Branding Portal"
          href="https://branding.fhnw.ch/document/22#/vorgaben/wort-bildmarke-1"
          target="_blank"
        >
          Kapitel des CD-Manuals
        </a>
        . Bei Fragen zur Nutzung wenden Sie sich an die
        Kommunikationsverantwortlichen Ihrer Hochschule.{' '}
      </p>
    </>
  );
};

export default Page;
